



































import { defineComponent, ref, watch } from '@vue/composition-api';
import { useRouter } from 'vivat';

import { moduleList } from '@/views/Report/Analytic/analytic-router';
import useAuth from '@/useAuth';

const Index = defineComponent({
  setup() {
    const { route } = useRouter();
    const { hasPermission } = useAuth();
    const showMenu = ref(route.value.name === 'AnalyticsIndex');

    watch(() => route.value.name, (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== 'AnalyticsIndex') showMenu.value = false;
      else if (newVal === 'AnalyticsIndex') showMenu.value = true;
    });

    return {
      hasPermission,
      showMenu,
      moduleList,
    };
  },
});

export default Index;
